import reducer from './translation';
import { actionCreators, TranslationActionType } from './translation.actionCreators';
import * as actionTypes from './translation.actionTypes';

export * from './translation'; // expose all types
export * from './translation.selectors';
export type ActionType = TranslationActionType;
export { actionTypes, actionCreators };
export default reducer;
